var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDsp4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.0561 2.98391C17.6258 1.55354 15.3066 1.55354 13.8763 2.98391C12.4459 4.41429 12.4459 6.73337 13.8763 8.16378L20.1822 14.4697C16.7715 18.3217 14.8733 23.3004 14.8733 28.4748V32.733C11.5282 32.7958 8.33348 34.1518 5.96326 36.5221C3.53568 38.9496 2.17188 42.2422 2.17188 45.6753V50.0736C2.17188 52.0965 3.81172 53.7364 5.83458 53.7364C7.85743 53.7364 9.4973 52.0965 9.4973 50.0736V45.6753C9.4973 44.185 10.0893 42.7557 11.1431 41.7019C12.1395 40.7056 13.4714 40.122 14.8733 40.0614V51.4826V53.8571V66.0724C14.8733 68.0952 16.5131 69.7351 18.536 69.7351C20.5589 69.7351 22.1987 68.0952 22.1987 66.0724V57.5198H49.8025V66.0724C49.8025 68.0952 51.4426 69.7351 53.4654 69.7351C55.4882 69.7351 57.1281 68.0952 57.1281 66.0724V53.8942V53.8571V40.0614C58.5302 40.122 59.8619 40.7055 60.8582 41.7019C61.9121 42.7557 62.5045 44.185 62.5045 45.6753V50.0736C62.5045 52.0965 64.1439 53.7364 66.1672 53.7364C68.19 53.7364 69.8299 52.0965 69.8299 50.0736V45.6753C69.8299 42.2422 68.4659 38.9496 66.0382 36.5221C63.6682 34.1518 60.4734 32.7957 57.1281 32.733V28.4748C57.1281 23.3004 55.2298 18.3217 51.8191 14.4696L58.1253 8.16378C59.5557 6.73337 59.5557 4.41429 58.1253 2.98391C56.6949 1.55354 54.3757 1.55354 52.9453 2.98391L46.0427 9.88642C42.9853 8.23484 39.5388 7.34739 36.0007 7.34739C32.4627 7.34739 29.0161 8.23484 25.9587 9.88642L19.0561 2.98391Z",
    fill: "#FFCACF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.0497 26.6357H14.9551C14.9019 27.2448 14.875 27.8582 14.875 28.4744V32.7403H57.1298V28.4744C57.1298 27.8582 57.1029 27.2448 57.0497 26.6357Z",
    fill: "#F84343"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDsp4);
export default __webpack_public_path__ + "static/media/dsp_4.d8ad94493b4567e44d4fb1c036cf6fdb.svg";
export { ForwardRef as ReactComponent };